// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';
import classNames from 'classnames';

export default class TextareaInput extends Component {

  static defaultProps = {
    isRequired: false,

    rows: 4,

    readOnly: false,

    resizable: false,

    max: 0,

    value: '',
  };

  static propTypes = {
    value: PropTypes.string,

    placeholder: PropTypes.string,

    /**
     * @param number The phone number
     */
    onChange: PropTypes.func.isRequired,

    className: PropTypes.string,

    isRequired: PropTypes.bool,

    rows: PropTypes.number,

    readOnly: PropTypes.bool,

    resizable: PropTypes.bool,

    max: PropTypes.number,

    onMaxReached: PropTypes.func,
  };

  onChange = (event: Event) => {
    const value = event.target.value;
    const { max, onMaxReached } = this.props;

    if (max !== 0 && value.length > max) {
      if (_.isFunction(onMaxReached)) {
        onMaxReached();
      }
    } else {
      this.props.onChange(value, event);
    }
  }

  render() {
    const { rows, placeholder, isRequired, value, max } = this.props;

    const className = classNames('form-control', this.props.className, {
      'resize-none': !this.props.resizable
    });

    return (
      <span className="textarea_input">
        <textarea
          onChange={this.onChange}
          placeholder={placeholder}
          value={value || ''}
          className={className}
          required={isRequired === true ? 'required' : ''}
          rows={rows}
          disabled={this.props.readOnly}
        />
        {max !== 0 &&
          <div
            className="textarea_input__counter"
          >
            {value.length} / {max}
          </div>
        }
      </span>
    );
  }

}
